export const DISCOUNT_CODE_STATUS = {
  draft: 'draft',
  pending: 'pending',
  checking: 'checking',
  valid: 'valid',
  invalid: 'invalid',
}

export { DISCOUNT_CODE_STATUS as default }
